import { render, staticRenderFns } from "./FixedColumnTable.vue?vue&type=template&id=203dc634&scoped=true&"
import script from "./FixedColumnTable.vue?vue&type=script&lang=js&"
export * from "./FixedColumnTable.vue?vue&type=script&lang=js&"
import style0 from "./FixedColumnTable.vue?vue&type=style&index=0&id=203dc634&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203dc634",
  null
  
)

export default component.exports